import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed, toRefs, useStore } from "@nuxtjs/composition-api";
import { RawLocation } from "vue-router";

import { useLinkService, useVuetify } from "@/composables";
import { getAmplitudeStore } from "@/store/amplitude";
import { useCreatorShop } from "@/store/creator-shop";
import { getTrendingPostsStore } from "@/store/trending-posts";
import { Actions } from "@/utils/snowplow/enums";
import { createPostImpression } from "@/utils/snowplow/factory";


export default /*#__PURE__*/_defineComponent({
  __name: 'TrendingPostsTile',
  props: {
  trendingPostId: {
    type: String,
    required: true,
  },
  to: {
    type: Object as PropType<RawLocation>,
    required: true,
  },
  referringComponent: {
    type: String,
    required: true,
    default: "",
  },
  position: {
    type: Number,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const vuetify = useVuetify();
const store = useStore();
const linkService = useLinkService();



const { trendingPostId, position, referringComponent } = toRefs(props);

const trendingPost = computed(() => {
  return getTrendingPostsStore(store).trendingPosts[trendingPostId.value];
});

const trendingPostImage = computed(() => {
  return trendingPost.value?.media.find((media) => media?.type === "picture");
});

const imageUrl = computed(() => {
  return trendingPostImage.value?.mediaCdnUrl
    ? linkService.getImageLink({
        url: trendingPostImage.value.mediaCdnUrl,
        width: imageSize.value.width,
        height: imageSize.value.height,
      })
    : null;
});

const imageSize = computed(() => {
  if (vuetify.breakpoint.xsOnly) {
    return { width: "138", height: "187" };
  } else {
    return { width: "168", height: "228" };
  }
});

const tileWidth = computed(() => {
  return vuetify.breakpoint.xsOnly ? "138" : "168";
});

const postImpressionPayload = computed(() =>
  createPostImpression(Actions.View, {
    id: trendingPost.value?.id ?? "",
    creator_id: trendingPost.value?.profileId ?? "",
    product_ids: trendingPost.value?.postProductIds,
    position: position.value,
  }),
);

const setReferringComponentAndShopTab = () => {
  getAmplitudeStore(store).setReferringComponent(referringComponent.value);
  useCreatorShop().setReferringShopTab();
};

return { __sfc: true,vuetify, store, linkService, props, trendingPostId, position, referringComponent, trendingPost, trendingPostImage, imageUrl, imageSize, tileWidth, postImpressionPayload, setReferringComponentAndShopTab }
}

})